const kiliLocale = {
  kili: {
    "pilot-oversight": {
      title: "Contrôle du pilotage à distance",
      messages: {
        authorized: "Pilotage à distance activé",
        "not-authorized": "Pilotage à distance désactivé",
      },
      form: {
        submit: "Confirmer",
        authorized: "Autoriser le pilotage à distance pour tout le site",
        "do-not-authorize": "Désactiver le pilotage à distance pour tout le site",
        siteId: {
          label: "Sélectionner un site",
          placeholder: "Ex. Mon Site",
        },
      },
    },
    support: {
      title: "Demande de support",
      messages: {
        success: "La demande de support a bien été envoyée",
      },
      form: {
        submit: "Envoyer la demande de support",
        siteId: {
          label: "Votre demande concerne quel site ?",
          placeholder: "Ex. Mon Site",
        },
        phoneNumber: {
          label: "A quel numéro peut-on joindre le gestionnaire ?",
          placeholder: "Ex. 0301020304",
        },
        email: {
          label: "Et indiquer également un mail (en cas d'appels sans réponses)",
          // https://stackoverflow.com/a/77771515
          placeholder: "{'Ex. contact@voltalis.com'}",
        },
        description: {
          label: "Commentaire",
          placeholder: "Ex. Les radiateurs du site ne fonctionnent pas",
        },
      },
    },
    "login-to-hospitality": {
      label: "Espace Enterprise",
      redirect: "Vous êtes sur le point d'être redirigé vers l'espace Enterprise de l'organisation",
      agreement:
        "L'accord de l'entreprise est obligatoire pour y accéder, et cette action de votre part sera enregistrée.",
      cta: "Accéder à l'espace Enterprise",
      cancel: "Annuler",
    },
    pages: {
      organization: {
        title: "Détails de l'organisation {orgName} (#{orgId})",
      },
    },
    "accommodation-sites": "Sites Hébergement",
    datatable: {
      resetFilter: "Réinitialiser tous les filtres",
      search: "Appliquer les filtres",
      site: {
        column: {
          "site-id": "Site ID",
          name: "Nom du site",
          organization: "Division parente",
          "street-number": "Numéro de rue",
          street: "Rue",
          "postal-code": "Code postal",
          city: "Ville",
        },
      },
    },
    site: {
      siteId: "Site id",
      name: "Nom",
      numDevices: "Nombre d'appareils",
      orgId: "Id d'orga.",
      orgName: "Nom d'orga.",
    },
  },
};

export type KiliLocale = typeof kiliLocale;
export default kiliLocale;
